import AuthService from 'lib/auth/AuthService';
import { apiClient } from '../../../v4/core/apiClient';
import { myGuestIdentityService } from '../../services/front/GuestIdentityService/GuestIdentityService.connected';
import { createShortlistFeedbackApi } from './shortlistFeedback.api.http';

export const myShortlistFeedbackApi = createShortlistFeedbackApi({
  client: apiClient,
  isSignedIn: () => AuthService.isAuthenticated(),
  getGuestId: () => myGuestIdentityService.getGuestId()
});
